export const INVALID_DATE = "invalidDate";
export const SMALL_ICON_SIZE = "16px";
export const EXAMPLE_EMAIL = "email@teltonika.lt";

export const API_DOCS_URL = "https://api.tacho.teltonika.lt/api-docs/v1";
export const CONVEY_ENDPOINT_URL =
  "https://api-files.conveyweb.co.uk/api/remotefiles/remotefilesupload";

export const ICON_DEFAULT_STYLE = { width: "16px", height: "16px" };
